import React from 'react';
import { Link } from 'react-router-dom';
import Seo from './Seo';
import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';
import PageAtmosphere from './PageAtmosphere';
import './Marketing.css';

export default function AboutPage() {
  return (
    <div className="marketing-page marketing-page--atmosphere">
      <Seo
        title="About 3AM AI — Our mission"
        description="3AM AI builds Life Journal so people can overcome anxiety, reach their goals, and understand their moods — with calm AI coaching for the quiet hours."
        path="/about"
      />
      <PageAtmosphere />
      <SiteNav />
      <main>
        <header className="page-hero">
          <div className="page-hero__inner m-animate-in">
            <p className="m-section__label">About</p>
            <h1>Why 3AM AI exists</h1>
            <p>
              Named for the hour when the noise drops and the truth shows up — and for the people who
              want that clarity in daylight too.
            </p>
          </div>
        </header>

        <div className="about-body m-animate-in m-animate-in--delay-1">
          <p>
            A lot of us know what it feels like to be capable and still stuck: anxious before the day
            starts, ambitious at night, foggy about what actually moved. We read advice. We restart
            on Monday. We carry the same loops into another week.
          </p>
          <p>
            <strong>3AM AI</strong> exists for that gap — between wanting a calmer mind and wanting
            real progress. We believe mental steadiness and productivity are not opposites. Anxiety
            softens when you can name it. Goals stick when they meet your real life. Mood awareness
            turns vague “bad days” into patterns you can work with.
          </p>

          <aside className="about-mission">
            <h2>Our mission</h2>
            <p>
              Help people overcome anxiety, reach meaningful goals, and stay aware of their mood —
              so they can think clearly and move with intention.
            </p>
          </aside>

          <p>
            That is why we built <strong>Life Journal</strong>: a private place to write what is true,
            track how you feel, aim at what matters, and talk it through with a calm AI coach. Not a
            feed. Not a performance. A quiet tool for honest hours.
          </p>
          <p>
            We do not sell hustle theater. We build for the moment you finally ask: what am I anxious
            about, what do I want, and what is the next step I will actually take?
          </p>
          <p>
            If that is the hour you are in — welcome. Start free, keep it private, and let clarity
            compound.
          </p>

          <div className="m-btn-row" style={{ marginTop: '2.5rem' }}>
            <Link to="/signup" className="m-btn m-btn--primary">
              Join 3AM AI free
            </Link>
            <Link to="/product#journey" className="m-btn m-btn--ghost">
              See how it works
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
